

import React from 'react';

const ProcurementPipeline = ({ onViewReport, values }) => {

  const pipelineData = [
    { id: 'pr', label: 'PR Created', value: values?.pr || "00", iconClass: 'bi bi-file-earmark-text', theme: 'blue' },
    { id: 'rfq', label: 'RFQ Created', value: values?.rfq || "00", iconClass: 'bi bi-people', theme: 'green' },
    { id: 'eval', label: 'Evaluation', value: values?.eval || "00", iconClass: 'bi bi-x-diamond', theme: 'purple' },
    { id: 'po', label: 'PO Released', value: values?.po || "00", iconClass: 'bi bi-cart', theme: 'orange' },
    { id: 'grn', label: 'GRN', value: values?.grn || "00", iconClass: 'bi bi-box', theme: 'green' },
    { id: 'invoice', label: 'Invoice', value: values?.invoice || "00", iconClass: 'bi bi-receipt', theme: 'purple' },
  ];


  return (
    <div
      className="dashboardWidget"
      style={{
        width: '100%',
        height: '93%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '20px 10px' // Extra breathing room inside the widget
      }}
    >

      {/* Header */}
      <div className="widgetHeader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h6 style={{ margin: 0, fontWeight: '700', fontSize: '15px', color: '#333' }}>Procurement Pipeline</h6>
        <span
          className="viewReportBtn"
          style={{ cursor: 'pointer', color: '#008FFB', fontWeight: 'bold', fontSize: '13px' }}
          onClick={() => onViewReport && onViewReport()}
        >
          View Report
        </span>
      </div>

      {/* Pipeline Container (Perfect vertical centering & spacing) */}
      <div
        className="pipeline"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          flexGrow: 1, // Pulls it to fill the remaining height
          padding: '15px 0',
          overflow: 'hidden'
        }}
      >
        {pipelineData.map((item, index) => (
          <React.Fragment key={item.id}>

            {/* Pipeline Item */}
            <div
              className="pipelineItem"
              style={{
                textAlign: 'center',
                flex: '0 0 auto',
                width: '75px', // Widened to cleanly fit larger text
                cursor: 'pointer',
                transition: 'transform 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              {/* Upgraded Larger Icon Circle */}
              <div
                className={`pipelineIcon ${item.theme}`}
                style={{
                  width: '46px',
                  height: '46px',
                  fontSize: '18px', // Larger Bootstrap Icon size
                  lineHeight: '46px',
                  margin: '0 auto',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.05)' // Subtle shadow for depth
                }}
              >
                <i className={item.iconClass}></i>
              </div>

              {/* Upgraded Highly Readable Label */}
              <p style={{
                margin: '10px 0 4px 0',
                fontSize: '11px', // Bumped size from 9px
                color: '#555',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {item.label}
              </p>

              {/* Upgraded Bolder Numeric Metrics */}
              <h5 style={{
                margin: 0,
                fontSize: '20px', // Bumped size from 12px
                fontWeight: '800', // Solid bold font weight
                color: '#111'
              }}>
                {item.value}
              </h5>
            </div>

            {/* Re-aligned Connector Line */}
            {index < pipelineData.length - 1 && (
              <div
                className="line"
                style={{
                  flex: '1 1 auto',
                  height: '2.5px', // Slightly thicker for visibility
                  backgroundColor: '#e2e8f0',
                  margin: '0 6px',
                  minWidth: '5px',
                  transform: 'translateY(-16px)' // Positioned to hit dead-center of 46px circles
                }}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProcurementPipeline;
